module.exports = __webpack_public_path__ + "static/media/zicta-logo3.31f99827.png";